/* Kallax landing — JS adapté du blopx.js du projet Claude Design (2026-07-20).
   Porté : comparateur avant/après, carrousels produits multiples, scrollspy catbar,
   menu mobile (burger), reveal on scroll, ajout panier AJAX (fallback POST natif).
   Non porté (mock maquette) : panier drawer en mémoire, recherche overlay locale,
   sélecteur de direction — le thème utilise les routes Shopify natives. */
(function () {
  'use strict';

  // Le script est inclus par le chrome (header) ET par les sections de page :
  // ne s'exécuter qu'une fois par chargement.
  if (window.__kallaxLandingJs) return;
  window.__kallaxLandingJs = true;

  const $  = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => [...r.querySelectorAll(s)];

  // ---------- comparateur avant/après ----------
  $$('.kallax-landing .compare').forEach((compare) => {
    const range  = $('input[type="range"]', compare);
    const setPos = (pct) => {
      const p = Math.max(0, Math.min(100, pct));
      compare.style.setProperty('--pos', p + '%');
      if (range) range.value = p;
    };
    setPos(range ? +range.value : 88);
    range && range.addEventListener('input', () => setPos(+range.value));

    let dragging = false;
    const posFromEvent = (clientX) => {
      const r = compare.getBoundingClientRect();
      return ((clientX - r.left) / r.width) * 100;
    };
    compare.addEventListener('pointerdown', (e) => {
      dragging = true;
      compare.setPointerCapture && compare.setPointerCapture(e.pointerId);
      setPos(posFromEvent(e.clientX));
    });
    compare.addEventListener('pointermove', (e) => {
      if (!dragging) return;
      setPos(posFromEvent(e.clientX));
    });
    const endDrag = () => { dragging = false; };
    compare.addEventListener('pointerup', endDrag);
    compare.addEventListener('pointercancel', endDrag);

    range && range.addEventListener('keydown', (e) => {
      if (e.key === 'ArrowLeft') setPos(+range.value - 4);
      else if (e.key === 'ArrowRight') setPos(+range.value + 4);
    });
  });

  // ---------- carrousels produits (multi-instances) ----------
  $$('.kallax-landing .carousel').forEach((carousel) => {
    const track = $('.carousel-track', carousel);
    if (!track) return;
    // les flèches vivent dans le section-head qui précède le carrousel
    const scope = carousel.closest('section, .kl-carousel-scope') || document;
    const prev = scope.querySelector('.carPrev');
    const next = scope.querySelector('.carNext');
    if (!prev || !next) return;
    const step = () => {
      const card = track.querySelector('.card');
      const gap = parseFloat(getComputedStyle(track).gap) || 22;
      return card ? card.offsetWidth + gap : 320;
    };
    const updateBtns = () => {
      const min = track._min || 0;
      const max = track.scrollWidth - track.clientWidth - 2;
      prev.disabled = track.scrollLeft <= min + 4;
      next.disabled = track.scrollLeft >= max;
    };
    track._min = track.scrollLeft;

    let anim;
    const animateTo = (target) => {
      cancelAnimationFrame(anim);
      const start = track.scrollLeft;
      const min = track._min || 0;
      const max = track.scrollWidth - track.clientWidth;
      const end = Math.max(min, Math.min(max, target));
      const dist = end - start;
      if (Math.abs(dist) < 1) return;
      const dur = 420, t0 = performance.now();
      const ease = (p) => 1 - Math.pow(1 - p, 3);
      const tick = (now) => {
        const p = Math.min(1, (now - t0) / dur);
        track.scrollLeft = start + dist * ease(p);
        updateBtns();
        if (p < 1) anim = requestAnimationFrame(tick);
      };
      anim = requestAnimationFrame(tick);
    };
    const scrollByCards = (dir) => animateTo(track.scrollLeft + dir * step() * 2);
    prev.addEventListener('click', () => scrollByCards(-1));
    next.addEventListener('click', () => scrollByCards(1));
    track.addEventListener('scroll', updateBtns, { passive: true });
    window.addEventListener('resize', () => { track._min = 0; updateBtns(); });
    updateBtns();
  });

  // ---------- header scroll (ombre) ----------
  const header = $('.kallax-landing .header');
  if (header) {
    const onScroll = () => header.classList.toggle('scrolled', window.scrollY > 8);
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  // ---------- sommaire catalogue : scrollspy ----------
  const catbar = $('.kallax-landing .catbar');
  if (catbar) {
    const links = $$('.catbar-link', catbar);
    const sections = links
      .map((l) => {
        const href = l.getAttribute('href') || '';
        const id = href.slice(href.indexOf('#') + 1);
        return id ? document.getElementById(id) : null;
      })
      .filter(Boolean);
    const setActive = () => {
      const y = window.scrollY + 140;
      let cur = 0;
      sections.forEach((s, i) => { if (s.offsetTop <= y) cur = i; });
      links.forEach((l, i) => l.classList.toggle('active', i === cur));
    };
    window.addEventListener('scroll', setActive, { passive: true });
    setActive();
  }

  // ---------- menu mobile (burger) ----------
  const mnav = $('.kallax-landing .mnav') || $('.mnav');
  const burger = $('.kallax-landing #burger') || $('#burger');
  if (mnav && burger) {
    const open = () => { mnav.classList.add('on'); document.body.style.overflow = 'hidden'; };
    const close = () => { mnav.classList.remove('on'); document.body.style.overflow = ''; };
    burger.addEventListener('click', open);
    const closeBtn = $('#mnavClose', mnav);
    closeBtn && closeBtn.addEventListener('click', close);
    $$('nav a', mnav).forEach((a) => a.addEventListener('click', close));
    document.addEventListener('keydown', (e) => { if (e.key === 'Escape') close(); });
  }

  // ---------- ancres douces (offset header sticky) ----------
  $$('.kallax-landing a[href^="#"]').forEach((a) => {
    a.addEventListener('click', (e) => {
      const id = a.getAttribute('href');
      if (!id || id.length < 2) return;
      const target = document.querySelector(id);
      if (!target) return;
      e.preventDefault();
      const y = target.getBoundingClientRect().top + window.scrollY - 80;
      window.scrollTo({ top: y, behavior: 'smooth' });
    });
  });

  // ---------- reveal on scroll (anim douce) ----------
  // Le masquage CSS (.reveal{opacity:0}) est scopé sous .kallax-landing.js-reveal :
  // on ne l'arme QUE si ce JS tourne, pour ne jamais laisser une page blanche sans JS.
  $$('.kallax-landing').forEach((root) => root.classList.add('js-reveal'));
  const els = $$('.kallax-landing .reveal');
  const revealAll = () => els.forEach((el) => el.classList.add('in'));
  if (els.length && 'IntersectionObserver' in window) {
    const io = new IntersectionObserver((entries) => {
      for (const e of entries) {
        if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); }
      }
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.05 });
    els.forEach((el) => io.observe(el));
    // failsafe : si l'observer ne se déclenche jamais (edge browsers), tout révéler après 2.5s
    setTimeout(revealAll, 2500);
  } else {
    revealAll();
  }

  // ---------- ajout panier AJAX (cartes produits) ----------
  const bumpCartCount = (count) => {
    const el = document.querySelector('[data-cart-count]');
    if (!el) return;
    el.textContent = count;
    el.classList.add('on');
  };
  $$('.kallax-landing .card form').forEach((form) => {
    form.addEventListener('submit', (e) => {
      const btn = form.querySelector('.add');
      if (!btn || btn.classList.contains('is-added')) return;
      e.preventDefault();
      btn.disabled = true;
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { Accept: 'application/json' },
        body: new FormData(form),
      })
        .then((r) => (r.ok ? r.json() : Promise.reject(r)))
        .then(() => fetch('/cart.js', { headers: { Accept: 'application/json' } }))
        .then((r) => r.json())
        .then((cart) => {
          bumpCartCount(cart.item_count);
          if (window.__kallaxCart) window.__kallaxCart.sync(cart, true);
          btn.disabled = false;
          btn.classList.add('is-added');
          btn.innerHTML =
            '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"/></svg> Ajouté';
        })
        .catch(() => {
          // échec AJAX → on laisse le POST natif vers /cart se faire
          btn.disabled = false;
          form.submit();
        });
    });
  });

  // ---------- recherche overlay (modif 1 — recherche prédictive curée) ----------
  // Filtre l'index #klSearchIndex (uniquement les collections de l'univers, jamais
  // le catalogue global) et rend les résultats comme le design Claude : compteur,
  // vignette, collection, spec, prix, état « aucun résultat ». Aucun ancien produit.
  (function () {
    const ov = $('#searchOv');
    const btn = $('#searchBtn');
    if (!ov || !btn) return;
    const input = $('#searchInput', ov);
    const form = $('#searchForm', ov);
    const results = $('#searchResults', ov);
    const sugg = $('#searchSugg', ov);

    let CATALOG = [];
    try {
      const raw = document.getElementById('klSearchIndex');
      if (raw) CATALOG = JSON.parse(raw.textContent || '[]');
    } catch (e) { CATALOG = []; }

    const norm = (s) => (s || '').toString().toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '');
    const esc = (s) => String(s == null ? '' : s).replace(/[&<>"]/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]));

    const render = (q) => {
      if (!results) return;
      const query = norm((q || '').trim());
      if (!query) { results.innerHTML = ''; results.hidden = true; if (sugg) sugg.hidden = false; return; }
      if (sugg) sugg.hidden = true;
      results.hidden = false;
      const matches = CATALOG.filter((p) => norm(p.n).includes(query) || norm(p.c).includes(query) || norm(p.s).includes(query));
      if (!matches.length) {
        results.innerHTML = '<p class="search-empty">Aucun résultat pour « ' + esc(q.trim()) + ' »</p>';
        return;
      }
      results.innerHTML = '<span class="search-count">' + matches.length + ' produit' + (matches.length > 1 ? 's' : '') + '</span>' +
        matches.map((p) =>
          '<a class="search-item" href="' + esc(p.u) + '">' +
            '<span class="si-thumb"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><path d="M21 8l-9-5-9 5v8l9 5 9-5V8z"/><path d="M3.3 7L12 12l8.7-5M12 22V12"/></svg></span>' +
            '<span class="si-main"><b>' + esc(p.n) + '</b><span class="si-coll">' + esc(p.c) + '</span></span>' +
            '<span class="si-spec">' + esc(p.s) + '</span>' +
            '<span class="si-price">€' + esc(p.p) + '</span>' +
          '</a>'
        ).join('');
    };

    const open = () => { ov.hidden = false; requestAnimationFrame(() => ov.classList.add('on')); setTimeout(() => input && input.focus(), 60); document.body.style.overflow = 'hidden'; };
    const close = () => { ov.classList.remove('on'); document.body.style.overflow = ''; setTimeout(() => { ov.hidden = true; }, 320); };

    btn.addEventListener('click', open);
    const cl = $('#searchClose', ov); cl && cl.addEventListener('click', close);
    ov.addEventListener('click', (e) => { if (e.target === ov) close(); });
    input && input.addEventListener('input', () => render(input.value));

    // recherches populaires → remplissent la recherche (pas de navigation directe)
    sugg && $$('.tags a', sugg).forEach((tag) => {
      tag.addEventListener('click', (e) => {
        e.preventDefault();
        input.value = tag.textContent.trim();
        render(input.value);
        input.focus();
      });
    });

    // clic sur un résultat : ferme l'overlay (la navigation suit)
    results && results.addEventListener('click', (e) => { if (e.target.closest('.search-item')) close(); });

    // Entrée → premier résultat curé (jamais la recherche globale)
    form && form.addEventListener('submit', (e) => {
      e.preventDefault();
      const first = results && results.querySelector('.search-item');
      if (first) { close(); window.location.href = first.getAttribute('href'); }
    });

    document.addEventListener('keydown', (e) => { if (e.key === 'Escape' && ov.classList.contains('on')) close(); });
  })();

  // ---------- panier drawer (modif 1 — ergonomie) ----------
  (function () {
    const drawer = $('#cartDrawer');
    const scrim = $('#cartScrim');
    const btn = $('#cartBtn');
    if (!drawer || !scrim || !btn) return;
    const itemsEl = $('#cartItems', drawer);
    const subEl = $('#cartSub', drawer);
    const cartUrl = (itemsEl && itemsEl.getAttribute('data-cart-url')) || '/cart';
    const money = (cents) => (cents / 100).toLocaleString('fr-BE', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' €';
    const esc = (s) => String(s == null ? '' : s).replace(/[&<>"]/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]));

    function render(cart) {
      if (!cart || !cart.items || !cart.items.length) {
        itemsEl.innerHTML = '<div class="cart-empty">Votre panier est vide.<span class="mono">Ajoutez un accessoire pour commencer.</span></div>';
      } else {
        itemsEl.innerHTML = cart.items.map((it) => {
          const img = it.image ? '<img src="' + it.image + '" alt="' + esc(it.product_title) + '">' : '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6"><rect x="3" y="3" width="18" height="18" rx="2"/><line x1="3" y1="12" x2="21" y2="12"/><line x1="12" y1="3" x2="12" y2="21"/></svg>';
          const variant = (it.variant_title && it.variant_title !== 'Default Title') ? it.variant_title : '';
          return '<div class="citem" data-key="' + it.key + '">' +
            '<div class="thumb">' + img + '</div>' +
            '<div class="meta"><b>' + esc(it.product_title) + '</b>' + (variant ? '<span class="v">' + esc(variant) + '</span>' : '') +
              '<span class="qty"><button type="button" data-act="dec" aria-label="Moins">–</button><span>' + it.quantity + '</span><button type="button" data-act="inc" aria-label="Plus">+</button></span></div>' +
            '<div style="text-align:right"><span class="pr">' + money(it.final_line_price) + '</span><br><button type="button" class="rm" data-act="rm">Retirer</button></div>' +
          '</div>';
        }).join('');
      }
      if (subEl) subEl.textContent = money(cart ? cart.total_price : 0);
      bumpCartCount(cart ? cart.item_count : 0);
    }
    function fetchCart() { return fetch('/cart.js', { headers: { Accept: 'application/json' } }).then((r) => r.json()); }
    function change(key, qty) {
      return fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ id: key, quantity: qty }) })
        .then((r) => r.json()).then(render);
    }
    const open = () => { drawer.hidden = false; scrim.classList.add('on'); requestAnimationFrame(() => drawer.classList.add('on')); document.body.style.overflow = 'hidden'; };
    const close = () => { drawer.classList.remove('on'); scrim.classList.remove('on'); document.body.style.overflow = ''; setTimeout(() => { drawer.hidden = true; }, 420); };

    btn.addEventListener('click', () => { open(); fetchCart().then(render).catch(() => {}); });
    const cl = $('#cartClose', drawer); cl && cl.addEventListener('click', close);
    scrim.addEventListener('click', close);
    document.addEventListener('keydown', (e) => { if (e.key === 'Escape' && drawer.classList.contains('on')) close(); });
    itemsEl.addEventListener('click', (e) => {
      const b = e.target.closest('button[data-act]'); if (!b) return;
      const row = b.closest('.citem'); if (!row) return;
      const key = row.getAttribute('data-key');
      const curr = parseInt(row.querySelector('.qty span').textContent, 10) || 0;
      const act = b.getAttribute('data-act');
      if (act === 'inc') change(key, curr + 1);
      else if (act === 'dec') change(key, Math.max(0, curr - 1));
      else if (act === 'rm') change(key, 0);
    });

    // exposé pour l'ajout panier AJAX
    window.__kallaxCart = { sync: (cart, doOpen) => { render(cart); if (doOpen) open(); } };
  })();
})();
